import { CASE_ENDPOINTS } from "@/Case/config";
import { HttpClient } from "@/App/services/HttpClient";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";

export default {
  open(payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.CASE_TRANSFER_OPEN(), payload));
  },
  accept(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_ACCEPT(caseTransferId)));
  },
  decline(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_DECLINE(caseTransferId)));
  },
  cancel(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_CANCEL(caseTransferId)));
  },
  request(caseTransferCode: String, payload: any): Promise<any> {
    return handleHttpRequest(HttpClient.post(CASE_ENDPOINTS.CASE_TRANSFER_REQUEST(caseTransferCode), payload));
  },
  requestCancel(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_REQUEST_CANCEL(caseTransferId)));
  },
  state(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.get(CASE_ENDPOINTS.CASE_TRANSFER_STATE(caseTransferId)));
  },
  received(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_RECEIVED(caseTransferId)));
  },
  acknowledge(caseTransferId: String): Promise<any> {
    return handleHttpRequest(HttpClient.patch(CASE_ENDPOINTS.CASE_TRANSFER_ACKNOWLEDGE(caseTransferId)));
  },
};
